import type { WaterPhaseVolumeFactorBwCalculator } from "../d";
export const waterPhaseVolumeFactorBwCalculator: WaterPhaseVolumeFactorBwCalculator =
  params => {
    const {
      temperatureF,
      inSituPressurePSIA,
      bubblePointPressurePSIA,
      salinity_ppm
    } = params;
    const deltaVwT = calculateDeltaVwT(temperatureF);
    const deltaVwP = calculateDeltaVwP(inSituPressurePSIA, temperatureF);

    const saturatedFVF = calculateSaturatedFVF(deltaVwT, deltaVwP);
    const deltaVwPAtPb = calculateDeltaVwPAtPb(
      bubblePointPressurePSIA,
      temperatureF
    );

    const PbFVF = calculatePbFVF(deltaVwPAtPb, deltaVwT);
    const waterCompressibility = calculateWaterCompressibility(
      inSituPressurePSIA,
      temperatureF,
      salinity_ppm
    );

    const undersaturatedFVF = calculateUndersaturatedFVF(
      PbFVF,
      waterCompressibility,
      inSituPressurePSIA,
      bubblePointPressurePSIA
    );
    const waterVolumeFactorBBLSTB = calculateWaterVolumeFactor(
      inSituPressurePSIA,
      bubblePointPressurePSIA,
      saturatedFVF,
      undersaturatedFVF
    );

    return {
      waterVolumeFactorBBLSTB,
      deltaVwT,
      deltaVwP,
      saturatedFVF,
      deltaVwPAtPb,
      PbFVF,
      waterCompressibility,
      undersaturatedFVF
    };
  };

// C36: =-1.0001(10^-2)+1.33391(10^-4)C3+5.50654(10^-7)C3^2
function calculateDeltaVwT(temperatureF: number): number {
  return (
    -1.0001e-2 +
    1.33391e-4 * temperatureF +
    5.50654e-7 * Math.pow(temperatureF, 2)
  );
}

// C37: =-1.95301(10^-9)(C2C3)-1.72834(10^-13)(C3C2^2)-3.58922(10^-7)C2-2.25341(10^-10)C2^2
function calculateDeltaVwP(
  inSituPressurePSIA: number,
  temperatureF: number
): number {
  return (
    -1.95301e-9 * (inSituPressurePSIA * temperatureF) -
    1.72834e-13 * (temperatureF * Math.pow(inSituPressurePSIA, 2)) -
    3.58922e-7 * inSituPressurePSIA -
    2.25341e-10 * Math.pow(inSituPressurePSIA, 2)
  );
}

// C39: =(1+C37)*(1+C36)
function calculateSaturatedFVF(deltaVwT: number, deltaVwP: number): number {
  return (1 + deltaVwT) * (1 + deltaVwP);
}

// C41: =-1.95301(10^-9)(C5C3)-1.72834(10^-13)(C3C5^2)-3.58922(10^-7)C5-2.25341(10^-10)C5^2
function calculateDeltaVwPAtPb(
  bubblePointPressurePSIA: number,
  temperatureF: number
): number {
  return (
    -1.95301e-9 * (bubblePointPressurePSIA * temperatureF) -
    1.72834e-13 * (temperatureF * Math.pow(bubblePointPressurePSIA, 2)) -
    3.58922e-7 * bubblePointPressurePSIA -
    2.25341e-10 * Math.pow(bubblePointPressurePSIA, 2)
  );
}

// C43: =(1+C41)*(1+C36)
function calculatePbFVF(deltaVwPAtPb: number, deltaVwT: number): number {
  return (1 + deltaVwPAtPb) * (1 + deltaVwT);
}

// C45: =1/(7.033C2+0.5415(C7/1000000)-537C3+403300)
function calculateWaterCompressibility(
  inSituPressurePSIA: number,
  temperatureF: number,
  salinity_ppm: number
): number {
  return (
    1 /
    (7.033 * inSituPressurePSIA +
      0.5415 * (salinity_ppm / 1000000) -
      537 * temperatureF +
      403300)
  );
}

// C47: =C43EXP(C45(C5-C2))
function calculateUndersaturatedFVF(
  PbFVF: number,
  waterCompressibility: number,
  inSituPressurePSIA: number,
  bubblePointPressurePSIA: number
): number {
  return (
    PbFVF *
    Math.exp(
      waterCompressibility * (bubblePointPressurePSIA - inSituPressurePSIA)
    )
  );
}

// C49: =IF(C2>C5,C47,C43)
function calculateWaterVolumeFactor(
  inSituPressurePSIA: number,
  bubblePointPressurePSIA: number,
  saturatedFVF: number,
  undersaturatedFVF: number
): number {
  return inSituPressurePSIA > bubblePointPressurePSIA
    ? undersaturatedFVF
    : saturatedFVF;
}
